module.exports = __webpack_public_path__ + "img/digital-doc.e2749fe5.gif";